import { c as _c } from "react/compiler-runtime";
import SeatSvg from "@assets/icons/seat.svg?react";
import { SvgIcon } from "@src/flat-ui/flat-ui-all";

/**
 * @param props to forward to the underlying icon
 * @returns a seat (armchair) icon, for the seats of the workspace subscription that members hold
 */
export function SeatIcon(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SvgIcon source={SeatSvg} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}